import { memo } from 'react';

import { Box, BoxProps, useBoolean } from '@chakra-ui/react';

import { Button } from 'ui/Button';

interface CardSelectProps extends BoxProps {
  onClick: () => void;
  isActive: boolean;
  bg: string;
  activeBg: string;
  activeBorder: string;
  activeColor: string;
}

const CardSelect = ({
  onClick,
  bg,
  isActive,
  activeBg,
  activeBorder,
  activeColor,
  ...props
}: CardSelectProps) => {
  const [isHovered, setIsHovered] = useBoolean(false);

  const activeLabel = isActive ? 'Selected' : 'Select';

  return (
    <Box
      onMouseEnter={setIsHovered.on}
      onMouseLeave={setIsHovered.off}
      {...props}
    >
      <Button
        colorScheme='primaryLight'
        variant='outline'
        onClick={onClick}
        fontSize='13px'
        h='35px'
        w='106px'
        bgColor={bg}
        py='9px'
        px='31px'
        isActive={isActive}
        _active={{
          background: activeBg,
          borderColor: activeBorder,
          color: activeColor
        }}
      >
        {isHovered && isActive ? 'unselect' : activeLabel}
      </Button>
    </Box>
  );
};

export default memo(CardSelect);
